var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tg-layout',[_c('tg-panel',{attrs:{"title":_vm.$t('page.rule.title')}},[_c('el-image',{attrs:{"src":_vm.ruleImage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }